"use client"

import type React from "react"
import { Grid, Typography, Box } from "@mui/material"
import ProductCard from "./ProductCard"
import type { Product } from "../types"

interface ProductGridProps {
    products: Product[]
    onProductClick: (product: Product) => void
    onInfoClick: () => void
}

const ProductGrid: React.FC<ProductGridProps> = ({ products, onProductClick, onInfoClick }) => {
    return (
        <Box>
            {products.length === 0 ? (
                <Box
                    sx={{
                        textAlign: "center",
                        padding: "80px 40px",
                        color: "#0d6336",
                        fontFamily: "'Montserrat', sans-serif",
                        fontSize: "18px",
                        minHeight: "50vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Typography variant="h6" color="primary">
                        No se encontraron cuadritos con los filtros seleccionados.
                    </Typography>
                </Box>
            ) : (
                <Grid container spacing={2}>
                    {products.map((product) => (
                        <Grid item xs={6} md={4} key={product.id}>
                            <ProductCard product={product} onClick={() => onProductClick(product)} onInfoClick={onInfoClick} />
                        </Grid>
                    ))}
                </Grid>
            )}
        </Box>
    )
}

export default ProductGrid

